import { Controller } from '@hotwired/stimulus';

const ROLES_WITHOUT_ORGANIZATIONS = ['regional_admin', 'local_admin'];
const ROLES_WITHOUT_VENUES = [
  ...ROLES_WITHOUT_ORGANIZATIONS,
  'care_management_admin',
  'care_coordinator',
  'nurse_practitioner',
];

export default class extends Controller {
  static targets = ['role', 'organization', 'venue'];

  connect() {
    this.toggleCountyAndVenues();
  }

  toggleCountyAndVenues() {
    if (this.hasRoleTarget) {
      const selectedRole = $(this.roleTarget).val();
      const showOrganizations = $.inArray(selectedRole, ROLES_WITHOUT_ORGANIZATIONS) === -1;
      const showVenues = $.inArray(selectedRole, ROLES_WITHOUT_VENUES) === -1;

      $(this.organizationTarget).toggle(showOrganizations);
      $(this.venueTarget).toggle(showVenues);
    }
  }
}
